import { filter, find, get, map, size, some } from 'lodash';
import { PROFILE_NUTRITION } from '../../constants';

import {
  selectNutritionProgram,
  selectNutritionPrograms,
  selectNutritionProgramIdForBmi,
  selectNutritionPreferences,
} from 'logic/nutritionPrograms';

export const SpeechBubbleNutrition = {
  transclude: true,

  bindings: {
    form: '<',
    member: '<',
    scrollTo: '&',
    onComplete: '&',
    onUpdate: '&',
  },

  template: `
    <div class="speech-bubble-nutrition py-4 bg-white">
      <!-- Step 1: What best describes you? -->
      <div class="speech-bubble-step" id="step-1">
        <speech-bubble class="fade-in-1">
          Hello!
        </speech-bubble>
        <speech-bubble class="fade-in-2">
          Now that the boring bit is done, let's set up your nutrition profile
          by answering 4 easy questions.
        </speech-bubble>
        <speech-bubble class="fade-in-3">
          <strong>What best describes you?</strong>
        </speech-bubble>
        <div class="text-right"
          ng-hide="$ctrl.isEditingStep1">
          <speech-bubble is-answer="true">
            {{ $ctrl.currentGoal }}
          </speech-bubble>
          <button type="button" class="btn btn-link mr-4"
            ng-click="$ctrl.isEditingStep1 = true">
            Change
          </button>
        </div>
        <div ng-class="{'fade-in-4': $ctrl.step === 1}">
          <div class="speech-bubble-row pt-3"
            ng-show="$ctrl.isEditingStep1">
            <form-radio-list
              form="$ctrl.form"
              name="goal"
              value="$ctrl.currentGoal"
              list="$ctrl.nutritionPrograms.goals"
              list-item-key="goal"
              list-item-title="goal"
              list-item-class="list-inline-item col-md-6"
              on-update="$ctrl.onSetProgram(key, value)">
            </form-radio-list>
          </div>
          <div class="speech-bubble-row w-100 p-0"
            ng-show="$ctrl.isEditingStep1">
            <button class="btn-link btn-continue"
              type="button"
              ng-click="$ctrl.onContinueStep(1)"
              ng-disabled="!$ctrl.currentGoal">
              <span>Continue</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Step 2: Calorie Level -->
      <div class="speech-bubble-step" id="step-2" ng-if="$ctrl.step >= 2">
        <speech-bubble class="fade-in-1">
          Thanks, based on that and your BMI of {{ $ctrl.member.bmi }}, I picked
          <strong>{{ $ctrl.defaultTitle }}</strong> for you
          <span ng-if="$ctrl.currentLevel.title !== $ctrl.defaultTitle">,
            but you have chosen <strong>{{ $ctrl.currentLevel.title }}</strong>
          </span>.
        </speech-bubble>
        <div class="speech-bubble-row fade-in-1"
          ng-hide="$ctrl.isEditingStep2">
          <button class="btn btn-link"
            type="button"
            ng-click="$ctrl.isEditingStep2 = true">
            Change
          </button>
        </div>
        <div ng-class="{'fade-in-2': $ctrl.step === 2}">
          <div class="speech-bubble-row pt-3"
            ng-show="$ctrl.isEditingStep2">
            <div nutrition-bmi="$ctrl.member.bmi"></div>
            <form-radio-list
              is-selectable="true"
              form="$ctrl.form"
              list="$ctrl.nutritionPrograms.programs"
              name="level"
              key="voomeProfile.level"
              value="$ctrl.currentLevel.id"
              list-item-key="id"
              list-item-title="title"
              list-item-class="list-inline-item col-md-6"
              on-update="$ctrl.onSetCalorieLevel(key, value)"
              required="true">
            </form-radio-list>
            <p>{{ $ctrl.currentLevel.description }}</p>
          </div>
          <div class="speech-bubble-row w-100 p-0"
            ng-show="$ctrl.isEditingStep2">
            <button class="btn btn-link btn-continue"
              type="button"
              ng-click="$ctrl.onContinueStep(2)">
              <span>Continue</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Step 3: Nutrition questions -->
      <div class="speech-bubble-step" id="step-3" ng-if="$ctrl.step >= 3">
        <div class="pt-1" id="index-{{ $index }}"
          ng-repeat="item in $ctrl.questions track by $index">
          <div class="speech-bubble-step"
            ng-if="$ctrl.index >= $index">
            <speech-bubble class="fade-in-1"
              ng-show="$index === 1">
              Great!
            </speech-bubble>
            <speech-bubble class="fade-in-1"
              ng-show="$index === 2">
              Awesome! Based on that, we will provide you with some great suggestions and inspiration!
            </speech-bubble>
            <speech-bubble class="fade-in-1"
              ng-show="$index === 3">
              Great, we have everything we need for your nutrition profile.
            </speech-bubble>
            <speech-bubble
              ng-show="$index < 3"
              ng-class="{
                'fade-in-2': ($index <= 1) && ($ctrl.index === $index),
                'fade-in-1': ($index > 1) && ($ctrl.index === $index)
              }">
              <strong >{{ item.question }}</strong>
            </speech-bubble>
            <button
              class="btn btn-link ml-4 mt-1 fade-in-2"
              type="button"
              ng-click="showAllergies = true"
              ng-show="$index === 3">
              {{ item.question }}
            </button>
            <speech-bubble class="text-right"
              is-answer="true"
              ng-hide="item.isActive">
              {{ item.answer || 'None Selected' }}
            </speech-bubble>
            <div class="speech-bubble-row text-right"
              ng-hide="item.isActive">
              <button class="btn btn-link"
                type="button"
                ng-click="item.isActive = true">
                Change
              </button>
            </div>
            <div class="speech-bubble-row pt-3"
              ng-show="item.isActive"
              ng-class="{
                'fade-in-3': ($index <= 1) && ($ctrl.index === $index),
                'fade-in-2': ($index > 1) && ($ctrl.index === $index)
              }">
              <form-fieldset
                ng-hide="$index === 3 && !showAllergies"
                form="$ctrl.form"
                name="key"
                key="voomeProfile.preferences.{{ item.key }}"
                list="$ctrl.member.voomeProfile.preferences[item.key]"
                type="{{ item.type }}"
                on-update="$ctrl.onUpdate({ key: key, value: value })">
              </form-fieldset>
            </div>
            <div class="speech-bubble-row full-width"
              ng-class="{
                'fade-in-3': ($index <= 1) && ($ctrl.index === $index),
                'fade-in-2': ($index > 1) && ($ctrl.index === $index)
              }">
              <button class="btn-link btn-continue"
                type="button"
                ng-click="$ctrl.onContinueIndex($index, item)"
                ng-show="item.isActive && $index < 3">
                <span>Continue</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        this.step = 1;
        this.index = 0;
        this.currentLevel = null;
        this.currentGoal = null;
        this.defaultTitle = null;

        // Set the editing state
        this.toggleEditingSteps();

        // Content for Question 1 & 2
        this.nutritionPrograms = selectNutritionPrograms(
          this.member.profile.gender,
          this.currentGoal
        );

        // Content for Question 3 & 4
        this.questions = this.reduceQuestions(PROFILE_NUTRITION);
      },

      reduceQuestions(questions) {
        return questions.map((item, index) => {
          return {
            ...item,
            isActive: index === this.index,
            answer: this.answersAsString(item.key),
          };
        });
      },

      answersAsString(key) {
        const answers = map(
          filter(this.member.voomeProfile.preferences[key], 'active'),
          'name'
        );

        return answers
          ? answers.length > 1 ? answers.join(', ') : answers[0]
          : null;
      },

      toggleEditingSteps() {
        [1, 2, 3, 4].forEach(
          i => (this[`isEditingStep${i}`] = i === this.step)
        );
      },

      onContinueStep(step) {
        if (step === this.step) {
          this.step = step + 1;
          this.scrollTo({ id: `step-${this.step}` });
        }

        this.toggleEditingSteps();

        if (this.step >= 4) {
          $timeout(() => this.onComplete(), 1000);
        }
      },

      onContinueIndex($index, item) {
        if ($index === this.index) {
          this.index = $index + 1;
          this.index === 3
            ? this.onContinueStep(3)
            : this.scrollTo({ id: `index-${this.index}` });
        }

        this.questions = this.reduceQuestions(this.questions);
      },

      onSetProgram(key, goal) {
        const { bmi } = this.member;
        const { gender } = this.member.profile;

        this.currentLevel = selectNutritionProgram({ goal, gender });
        this.currentGoal = this.currentLevel.goal;
        this.defaultTitle = this.currentLevel.title;

        this.onUpdate({
          key: 'voomeProfile.nutritionProgramId',
          value: selectNutritionProgramIdForBmi(this.currentLevel.id, bmi),
        });
      },

      onSetCalorieLevel(key, level) {
        this.currentLevel = find(this.nutritionPrograms.programs, {
          id: level,
        });

        this.onUpdate({ key, value: level });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/SpeechBubble/SpeechBubbleNutrition.js